
import Vue from 'vue'
import { MAX_END_SESSION_TIME } from '@/constants/business'

const validate = (value, { time = MAX_END_SESSION_TIME, timeFormat = 'HH:mm:ss' } = {}) => {
  if (Vue.isTestMode()) {
    return true
  }

  if (!value) return false

  const endDate = Vue.prototype.$moment(value)

  const topTimeBoundaries = Vue.prototype.$moment(time, timeFormat)

  return topTimeBoundaries.isSameOrAfter(Vue.prototype.$moment(endDate.format(timeFormat), timeFormat))
}

export default {
  validate,
  params: ['prolongation']
}
